import {EventBus} from "@/main";
import {EventBusKey} from "@/constant/Constants";
import store from "@/store";

export const HandleResize = {
    data() {
        return{
            clientHeight: 0,
            offsetHeight: 0,
            clientWidth: 0,
            offsetWidth: 0,
        }
    },
    computed: {

    },
    created() {
    },
    mounted() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize, true)
        EventBus.$on(EventBusKey.resize, ({width, height}) => {
            console.log('width,height',width,height)
        })
    },
    beforeDestroy() {
        EventBus.$off(EventBusKey.resize);
    },
    destroyed() {
        window.removeEventListener('resize',this.handleResize)
    },
    methods: {
        handleResize() {
            var element = document.documentElement;
            this.clientHeight = element.clientHeight;
            this.offsetHeight = element.offsetHeight;
            this.clientWidth = element.clientWidth;
            this.offsetWidth = element.offsetWidth;
            store.commit('commitValue',{key:'clientHeight', value: this.clientHeight})
            store.commit('commitValue',{key:'offsetHeight', value: this.offsetHeight})
            store.commit('commitValue',{key:'clientWidth', value: this.clientWidth})
            store.commit('commitValue',{key:'offsetWidth', value: this.offsetWidth})
        },
    },
    filters:{

    },watch:{

    }
}
